<template>
  <v-container fluid>
    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>
    <div class="d-flex flex-column justify-center align-center">

      <div class="col-12 col-lg-6">
        <v-card tile flat>
          <v-card-text class="d-flex flex-column justify-center align-center text-center">
            <h2>{{ $t('cards.titles.activate') }}</h2>
            <h3 class="mt-4">{{ $t('cards.titles.activatesub') }}</h3>
          </v-card-text>
        </v-card>
      </div>
    </div>


    <div class="d-flex flex-column justify-center align-center">
      
      <div class="col-12 col-lg-6">
        <v-card tile flat>
          <v-card-title class="d-flex justify-center align-center text-center">
            {{ $t('cards.titles.email') }}
          </v-card-title>
          <v-card-text>
            <v-text-field
                v-model="email"
                :label="$t('forms.email')"
                :error="hasError"
            ></v-text-field>
            <div class="d-flex flex-nowrap align-center my-1">
              <v-checkbox
                  class="ma-0 mr2"
                  v-model="privacyCheck"
                  hide-details
              ></v-checkbox>
              <div v-html="$t('forms.agreePrivacy')"></div>
            </div>
            <div class="d-flex flex-nowrap align-center my-1">
              <v-checkbox
                  class="ma-0 mr2"
                  v-model="tosCheck"
                  hide-details
              ></v-checkbox>
              <div v-html="$t('forms.agreeTos')"></div>
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
                :disabled="!email || !privacyCheck || !tosCheck"
                tile
                depressed
                color="primary"
                @click.prevent="navigate"
            >
              {{ $t('buttons.next') }}
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-alert
            v-if="errorReason === 'user_unknown'"
            class="mt-3"
            text
            tile
            type="error"
        >
          <div v-html="$t('alerts.wrongEmail')">
          </div>
        </v-alert>

        <v-alert
            v-if="errorReason === 'already_activated'"
            class="mt-3"
            text
            tile
            type="error"
        >
          <div v-html="$t('alerts.already_activated')">
           
          </div>
        </v-alert>
      </div>

    </div>

  </v-container>
</template>

<script>
import i18n from "@/services/i18n";
import maxios from "@/services/mediligo-axios";

export default {
  i18n: i18n,
  name: "m2h-activate",
  props: ['session-id'],
  components: {},
  data() {
    return {
      isLoading: false,
      email: '',
      hasError: false,
      errorReason: null,
      privacyCheck: false,
      tosCheck: false,
    }
  },
  mounted() {
  },

  methods: {
    async navigate() {
      const res = await maxios.post("/api/onboarding/activate", {email: this.email, session: this.sessionId, lang: this.$i18n.locale})
      if (!res.data.success) {
        this.hasError = true;
        console.log(res.data);
        this.errorReason = res.data.reason;
      } else {
        window.location.href = `/activateconfirm/${this.sessionId}?lang=${this.$i18n.locale}` ;
      }
    }
  },
}
</script>

<style scoped>

</style>
